"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.defaultBlue = exports.visitedGreen = exports.STATUS_ICON_MAP_VISITED = exports.STATUS_ICON_MAP = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("../util/constants");

var _mapPositionUtils = require("../util/mapPositionUtils");

var _jsxFileName = "/builds/zillow/searchxp/zillow-map-control/src/PropertyMarkers/PropertyDot.jsx";

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var STATUS_ICON_MAP = {
  FOR_SALE: _constants.zsgColorHometypeForSale,
  FOR_RENT: _constants.zsgColorHometypeForRent,
  SOLD: _constants.zsgColorHometypeRecentlySold,
  MMM: _constants.zsgColorHometypeForSale,
  OTHER: _constants.zsgColorHometypeOffMarket,
  PENDING: _constants.zsgColorHometypeForSale,
  RECENTLY_SOLD: _constants.zsgColorHometypeRecentlySold,
  FORECLOSED: _constants.zsgColorHometypeForSale,
  PRE_FORECLOSURE: _constants.zsgColorHometypeForSale,
  SALES_CENTER: _constants.black,
  INACTIVE: _constants.gray400
};
exports.STATUS_ICON_MAP = STATUS_ICON_MAP;
var STATUS_ICON_MAP_VISITED = {
  FOR_SALE: _constants.zsgColorHometypeForSaleVisited,
  FOR_RENT: _constants.zsgColorHometypeForRentVisited,
  SOLD: _constants.zsgColorHometypeRecentlySoldVisited,
  MMM: _constants.zsgColorHometypeForSaleVisited,
  OTHER: _constants.zsgColorHometypeOffMarketVisited,
  PENDING: _constants.zsgColorHometypeForSaleVisited,
  RECENTLY_SOLD: _constants.zsgColorHometypeRecentlySoldVisited,
  FORECLOSED: _constants.zsgColorHometypeForSaleVisited,
  PRE_FORECLOSURE: _constants.zsgColorHometypeForSaleVisited,
  SALES_CENTER: _constants.gray400,
  INACTIVE: _constants.gray400
};
exports.STATUS_ICON_MAP_VISITED = STATUS_ICON_MAP_VISITED;
var visitedGreen = 'rgba(3, 192, 74, 1)';
exports.visitedGreen = visitedGreen;
var defaultBlue = 'blue';
exports.defaultBlue = defaultBlue;

var PropertyDot =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(PropertyDot, _PureComponent);

  function PropertyDot() {
    return _PureComponent.apply(this, arguments) || this;
  }

  var _proto = PropertyDot.prototype;

  _proto.getColorFromStatus = function getColorFromStatus() {
    if (this.props.notificationHighlight) {
      return _constants.zsgColorNotification;
    }

    if (this.props.visited) {
      if (this.props.isCommunityEdgeCase) {
        return _constants.zsgColorHometypeForSaleVisited;
      }

      return STATUS_ICON_MAP_VISITED[this.props.statusType] || defaultBlue;
    }

    if (this.props.isCommunityEdgeCase) {
      return _constants.zsgColorHometypeForSale;
    }

    return STATUS_ICON_MAP[this.props.statusType] || defaultBlue;
  };

  _proto.getFill = function getFill() {
    return this.props.isHovered ? visitedGreen : this.getColorFromStatus();
  };

  _proto.renderSavedDot = function renderSavedDot() {
    var disableOutline = this.props.disableOutline;
    var fill = this.getFill(); // The shadow of the heart has a Blur and a Blend to get the gentle fade effect we want.
    // SXP-6701 We apply a group filter to a single path to get around a Safari bug

    var heartShadow = _react.default.createElement("svg", {
      className: "detail-styling",
      style: {
        marginBottom: '-5px',
        position: "absolute",
        left: "-12px",
        top: "-6px"
      },
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      x: "0px",
      y: "0px",
      width: "35px",
      height: "25px",
      viewBox: "-5.5 -4 35 35",
      enableBackground: "new 0 0 25 25",
      __source: {
        fileName: _jsxFileName,
        lineNumber: 81
      },
      __self: this
    }, _react.default.createElement("defs", {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 97
      },
      __self: this
    }, _react.default.createElement("filter", {
      x: "-10%",
      y: "-15%",
      width: "120%",
      height: "130%",
      id: "filter1",
      __source: {
        fileName: _jsxFileName,
        lineNumber: 98
      },
      __self: this
    }, _react.default.createElement("feOffset", {
      result: "offOut",
      in: "SourceAlpha",
      dx: "0",
      dy: "1.5",
      __source: {
        fileName: _jsxFileName,
        lineNumber: 99
      },
      __self: this
    }), _react.default.createElement("feGaussianBlur", {
      result: "blurOut",
      in: "offOut",
      stdDeviation: "2",
      __source: {
        fileName: _jsxFileName,
        lineNumber: 100
      },
      __self: this
    }), _react.default.createElement("feBlend", {
      in: "SourceGraphic",
      in2: "blurOut",
      mode: "normal",
      __source: {
        fileName: _jsxFileName,
        lineNumber: 101
      },
      __self: this
    }))), _react.default.createElement("g", {
      filter: "url(#filter1)",
      __source: {
        fileName: _jsxFileName,
        lineNumber: 104
      },
      __self: this
    }, _react.default.createElement("path", {
      stroke: "white",
      strokeWidth: "2px",
      fill: fill,
      d: "M18.7,2.5 c-2.6,0-5.1,1.5-6.2,3.6 C11.4,4,8.9,2.5,6.3,2.5 C2.8,2.5,0,5.3,0,8.8 c0,1.7,0.7,3.3,1.9,4.5l9.6,9.1 c0.3,0.3,0.7,0.4,1,0.4 c0.4,0,0.7-0.1,1-0.4l9.7-9.2 c0,0,0,0,0.1-0.1 C24.4,12,25,10.4,25,8.8 C25,5.3,22.2,2.5,18.7,2.5 z",
      __source: {
        fileName: _jsxFileName,
        lineNumber: 105
      },
      __self: this
    }))); // The filled portion of the heart is the bright colored center with crisp edges.


    var heartBody = _react.default.createElement("svg", {
      className: "quick-styling",
      style: {
        marginBottom: '-5px',
        position: "absolute",
        left: "-12px",
        top: "-6px"
      },
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      x: "0px",
      y: "0px",
      width: "35px",
      height: "25px",
      viewBox: "-5.5 -8 35 35",
      enableBackground: "new 0 0 25 25",
      __source: {
        fileName: _jsxFileName,
        lineNumber: 126
      },
      __self: this
    }, _react.default.createElement("path", {
      stroke: "white",
      strokeWidth: "2px",
      fill: fill,
      d: "M18.7,2.5 c-2.6,0-5.1,1.5-6.2,3.6 C11.4,4,8.9,2.5,6.3,2.5 C2.8,2.5,0,5.3,0,8.8 c0,1.7,0.7,3.3,1.9,4.5l9.6,9.1 c0.3,0.3,0.7,0.4,1,0.4 c0.4,0,0.7-0.1,1-0.4l9.7-9.2 c0,0,0,0,0.1-0.1 C24.4,12,25,10.4,25,8.8 C25,5.3,22.2,2.5,18.7,2.5 z",
      __source: {
        fileName: _jsxFileName,
        lineNumber: 142
      },
      __self: this
    }));

    var forwardProps = (0, _mapPositionUtils.getForwardableProperties)(this.props);
    forwardProps.className = "saved-property-dot " + forwardProps.className;

    if (disableOutline) {
      forwardProps.className += ' no-outline';
    }

    return _react.default.createElement("div", _extends({}, forwardProps, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 166
      },
      __self: this
    }), heartShadow, heartBody, this.props.children);
  };

  _proto.renderDefaultDot = function renderDefaultDot() {
    var _this$props = this.props,
        overText = _this$props.overText,
        disableOutline = _this$props.disableOutline;

    var dotStyle = _objectSpread({}, this.props.style, {
      /* eslint-disable react/prop-types */
      background: this.getFill()
    });

    var overTextClass = overText && overText.length > 1 ? 'large-over-text' : '';
    var forwardProps = (0, _mapPositionUtils.getForwardableProperties)(this.props);
    forwardProps.className = "property-dot " + overTextClass + " " + forwardProps.className;

    if (disableOutline) {
      forwardProps.className += ' no-outline';
    }

    delete forwardProps.style;
    return _react.default.createElement("div", _extends({}, forwardProps, {
      style: dotStyle,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 191
      },
      __self: this
    }), overText, this.props.children);
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        showDot = _this$props2.showDot,
        favorite = _this$props2.favorite; // Never show dot for off market properties.

    if (!showDot) {
      return null;
    }

    return favorite ? this.renderSavedDot() : this.renderDefaultDot();
  };

  return PropertyDot;
}(_react.PureComponent);

PropertyDot.propTypes = process.env.NODE_ENV !== "production" ? {
  isCommunityEdgeCase: _propTypes.default.bool,
  statusType: _propTypes.default.oneOf([''].concat(_toConsumableArray(Object.keys(STATUS_ICON_MAP)))),
  showDot: _propTypes.default.bool,
  isHovered: _propTypes.default.bool,
  overText: _propTypes.default.string,
  favorite: _propTypes.default.bool,
  visited: _propTypes.default.bool,
  notificationHighlight: _propTypes.default.bool,
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
  disableOutline: _propTypes.default.bool
} : {};
PropertyDot.defaultProps = {
  // isCommunityEdgeCase is a temp workaround for responsive desktop turn up 
  // under a very specific case
  // it should not be reused and is here to display For_Sale dot colors
  isCommunityEdgeCase: false,
  statusType: '',
  showDot: false,
  isHovered: false,
  overText: '',
  favorite: false,
  visited: false,
  notificationHighlight: false,
  children: [],
  disableOutline: false
};
var _default = PropertyDot;
exports.default = _default;